import { STATUS_COLOR_VAR, STATUS_LABEL, type ValidationStatus } from "../tokens";
export function StatusChip({ status }: { status: ValidationStatus }) {
  const color = STATUS_COLOR_VAR[status];
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ background: `color-mix(in srgb, ${color} 18%, transparent)`, color }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
